
import { Component, Vue } from 'vue-property-decorator'

import isMobile from '@/widget/utils/isMobile'

@Component
export default class LegacyLayout extends Vue {
  isMobile = isMobile()
}
